import React, { useState } from "react";
import {
  Upload, CheckCircle2, Users, ShoppingCart
} from "lucide-react";
import "./DataUploadPage.css";
import FileUploader from "../components/FileUploader";
import FileHistory from "../components/FileHistory";

// ── Mock upload history ──────────────────────────────────────────
const MOCK_HISTORY = [];

const FILE_TYPES = [
  {
    id: "customers",
    label: "Customers",
    icon: <Users size={20} />,
    desc: "Customer records — name, email, address, phone",
    table: "public.customers",
    color: "blue",
  },
  {
    id: "sales",
    label: "Sales",
    icon: <ShoppingCart size={20} />,
    desc: "Sales transactions — product, quantity, amount, date",
    table: "public.sales",
    color: "green",
  },
];


export default function DataUploadPage() {
  const [selectedType, setSelectedType] = useState(null);
  const [refreshHistory, setRefreshHistory] = useState(0);

  const handleUploadComplete = () => {
    setRefreshHistory(prev => prev + 1);
  };

  return (
    <div className="upload-root">
      {/* Page header */}
      <div className="page-header">
        <div className="page-header-left">
          <div className="page-icon page-icon-green">
            <Upload size={20} />
          </div>
          <div>
            <h1 className="page-title">Data Upload</h1>
            <p className="page-subtitle">
              Upload CSV files to load data into your RDS tables. Files are validated,
              cleaned, and deduplicated automatically.
            </p>
          </div>
        </div>
      </div>

      {/* Upload section */}
      <div className="upload-section">
        <div className="section-header">
          <h2 className="section-title">Upload New File</h2>
        </div>

        {/* File type selector */}
        <div className="type-selector">
          {FILE_TYPES.map((ft) => (
            <button
              key={ft.id}
              className={`type-card ${selectedType === ft.id ? `type-card-active type-card-${ft.color}` : ""}`}
              onClick={() => setSelectedType(ft.id)}
            >
              <div className={`type-icon type-icon-${ft.color}`}>{ft.icon}</div>
              <div className="type-body">
                <div className="type-label">{ft.label}</div>
                <div className="type-desc">{ft.desc}</div>
                <div className="type-table">→ {ft.table}</div>
              </div>
              {selectedType === ft.id && (
                <div className="type-check"><CheckCircle2 size={16} /></div>
              )}
            </button>
          ))}
        </div>

        {/* Drop zone replaced by real AWS FileUploader */}
        {selectedType && (
          <div style={{ marginTop: '24px' }}>
            <FileUploader fileType={selectedType} onUploadComplete={handleUploadComplete} />
          </div>
        )}

        {!selectedType && (
          <div className="upload-placeholder">
            <Upload size={24} />
            <span>Select a file type above to start uploading</span>
          </div>
        )}
      </div>

      {/* History section replaced by real AWS FileHistory */}
      <div className="history-section" style={{ marginTop: '32px', padding: '24px', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px' }}>
        <FileHistory refreshTrigger={refreshHistory} />
      </div>
    </div>
  );
}
